<template>
  <div v-if="currentConnaissance">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-12">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Prenom &amp; Nom </span>
                  </td>
                  <td>
                    {{ currentConnaissance.prenom }}
                    {{ currentConnaissance.nom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Societé / Entreprise</span>
                  </td>
                  <td>
                    {{ currentConnaissance.societe }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Poste / Fonction</span>
                  </td>
                  <td>
                    {{ currentConnaissance.poste_fonction }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-envelope text-custom-primary"></i>
                    <span class="font-weight-bold"> Email</span>
                  </td>
                  <td>
                    {{ currentConnaissance.email }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-phone text-custom-primary"></i>
                    <span class="font-weight-bold"> Téléphone</span>
                  </td>
                  <td>
                    {{ currentConnaissance.telephone }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-fax text-custom-primary"></i>
                    <span class="font-weight-bold"> Fax</span>
                  </td>
                  <td>
                    {{ currentConnaissance.fax }}
                  </td>
                </tr>

                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Departement</span>
                  </td>
                  <td>
                    {{ currentConnaissance.departement }}
                  </td>
                </tr>

                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Pays</span>
                  </td>
                  <td>
                    {{ currentConnaissance.pays }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Ville</span>
                  </td>
                  <td>
                    {{ currentConnaissance.ville }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-address-card text-custom-primary"></i>
                    <span class="font-weight-bold"> Adresse</span>
                  </td>
                  <td>
                    {{ currentConnaissance.adresse }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Code postal</span>
                  </td>
                  <td>
                    {{ currentConnaissance.code_postal }}
                  </td>
                </tr>

                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td>
                    {{ currentConnaissance.auteur }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

import config from '@/config';

export default {
  data() {
    return {
      title: 'Gestion contact - Détails',
      URL_LOCAL_FILE: config.URL_LOCAL_FILE,
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  computed: {
    ...mapGetters('tiersConnaissance', ['currentConnaissance']),
  },
  methods: {
    ...mapActions('tiersConnaissance', ['getConnaissance']),
    init() {
      this.getConnaissance(this.$route.params.id);
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
